import { connect } from "react-redux"
import LayoutMarkers from "./LayoutMarkers"

const mapStateToProps = (state, props) => ({
	layoutIds: Object.keys(state.layoutDetails),
})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(LayoutMarkers)
